<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :form="form"
    :title="$t('model.operationLog')"
    resource="operation_logs"
    :actionColumnProps="{ width: 80 }"
  />
</template>

<script>
import { Vue, Component, Prop, Mixins } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '../admin_grapes/operation_logs.js';
import { abilityService } from 'beans-admin-plugin';
import Utils from '../components/utils.vue';
import _ from 'lodash';
import OperationLogDetail from '@/components/operation-log-detail.vue';
import { displayText } from '@/custom_models_extend';

@Component({
  components: {
    OperationLogDetail
  }
})
export default class OperationLogs extends Mixins(Vue, Utils) {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    const array = [
      {
        prop: 'event_eq',
        label: this.$t('operationLog.event'),
        renderCell: {
          component: 'select',
          props: {
            clearable: true,
            options: _.reduce({
              pick: '领取',
              release: '释放',
              business_executive_release: '业务主管释放',
              assign: '转接',
              apply_assign: '申请转接',
              cancel_apply_assign: '取消申请转接',
              approve_assign: '同意转接',
              reject_assign: '拒绝转接',
            }, (acc, value, key) => {
              acc.push({ value: key, label: value });
              return acc;
            }, [])
          }
        }
      },
      abilityService.can('users.read_options') && {
        prop: 'operator_id_eq',
        label: this.$t('operationLog.operator'),
        renderCell: {
          component: 'select',
          props: {
            clearable: true,
            xRemotePreload: async () => {
              return (await this.$request.get('users/read_options', { per_page: 100, ...this.userOptionsFilter })).data.map(item => ({ value: item.id, label: displayText(item) }));
            },
            xRemoteSearch: async (keyword) => {
              return (await this.$request.get('users/read_options', { keyword, ...this.userOptionsFilter })).data.map(item => ({ value: item.id, label: displayText(item) }));
            }
          },
        }
      },
      {
        prop: 'target_id_eq',
        label: this.$t('operationLog.target'),
        renderCell: {
          component: 'select',
          props: {
            clearable: true,
            xRemotePreload: async () => {
              return (await this.$request.get('customers/read_options', { per_page: 100, ...this.customerOptionsFilter })).data.map(item => ({ value: item.id, label: item.name }));
            },
            xRemoteSearch: async (keyword) => {
              return (await this.$request.get('customers/read_options', { keyword, ...this.customerOptionsFilter })).data.map(item => ({ value: item.id, label: item.name }));
            }
          }
        }
      },
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  columns(h, { type }) {
    const array = [
      type === 'show' && 'id',
      'operator',
      {
        prop: 'content',
        label: '内容',
        width: 300,
        renderCell(h, { props: { scope: { row } } }) {
          return <OperationLogDetail operationLog={row} />
        }
      },
      'created_at',
      type === 'show' && 'updated_at',
    ].filter(Boolean)

    return columnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource - RESTful api resoure name
   * @param {Object} params.data - current form data
   * @param {Function} params.change - invoke this method to sync form change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    const array = [

    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove }) {
    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'operation_logs.edit', params: { id: row.id } }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'operation_logs.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }
}

export const route = [
  {
    path: '/operation_logs',
    name: 'operation_logs.index',
    component: OperationLogs,
    props: {
      type: 'index',
    }
  },
  {
    path: '/operation_logs/new',
    name: 'operation_logs.new',
    component: OperationLogs,
    props: {
      type: 'new',
    }
  },
  {
    path: '/operation_logs/:id',
    name: 'operation_logs.show',
    component: OperationLogs,
    props: {
      type: 'show',
    }
  },
  {
    path: '/operation_logs/:id/edit',
    name: 'operation_logs.edit',
    component: OperationLogs,
    props: {
      type: 'edit'
    }
  }
]
</script>
